import React from 'react'
import tableSizes from '../ViewersTable/viewers-table-sizes.module.scss'
import styles from './ViewerInfoLine.module.scss'
import cl from 'classnames'
import { IconMinusCircle, IconPlusCircle, IconPencil, IconEnvelope, IconUsers, IconCalendarDate, IconLocation } from 'assets'
import { AvatarImage, IconButton } from 'components/common'
import { ROUTING_STORE, VIEWERS_STORE } from 'store'
import { inject } from 'mobx-react'
import { ViewerInfoLineProps } from './types'
import { SortTabEnums } from 'pages/viewers/ViewersPage/SortTabs'
import { useGetIsResponsiveScreen } from 'utilities'

const ViewerInfoLineComponent = (props: ViewerInfoLineProps) => {
  const {
    singleLine,
    expanded,
    toggleExpand,
    viewer,
    [ROUTING_STORE]: { push },
    [VIEWERS_STORE]: { setCurrentViewer, selectedSortTab }
  } = props

  const { isResponsive: isLargeMobile } = useGetIsResponsiveScreen('(max-width: 600px)')

  const handleViewerDetailsClick = () => {
    setCurrentViewer(viewer)
    push(`/viewers/${id}`)
  }

  const {
    id,
    fullName,
    imageUrl,
    emailAddress,
    gender,
    birthDate,
    age,
    fullAddress
  } = viewer

  const dynamicValue = {
    [SortTabEnums.TOTAL_WATCH]: viewer.totalWatchTimeAsString,
    [SortTabEnums.INTERACTION_TIME]: viewer.totalInteractionTimeAsString,
    [SortTabEnums.ADD_REVENUE]: viewer.totalAddRevenueAsString,
    [SortTabEnums.TOTAL_SPENT]: viewer.totalSpentAsString
  }[selectedSortTab]

  const handleExpandIconClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    event.stopPropagation()
    toggleExpand()
  }

  return (
    <div className={cl(styles.main, { [styles.singleLine]: singleLine })}>
      <h4 style={{ width: tableSizes.fullNameWidth }} onClick={handleViewerDetailsClick}>
        {!singleLine && (expanded
          ? <IconMinusCircle onClick={handleExpandIconClick} />
          : <IconPlusCircle onClick={handleExpandIconClick} />)
        }
        <AvatarImage src={imageUrl} size={36} />
        <span>{fullName}</span>
      </h4>
      {!singleLine &&
        <div style={{ width: !isLargeMobile && tableSizes.dynamicColWidth, justifyContent: 'center' }}>
          <span>{dynamicValue}</span>
        </div>}
      <div style={{ width: !isLargeMobile && tableSizes.emailWidth }}>
        {singleLine && <IconEnvelope />}
        <span>{emailAddress}</span>
      </div>
      <div style={{ width: !isLargeMobile && tableSizes.genderWidth, display: 'flex', justifyContent: 'center' }}>
        {singleLine && <IconUsers />}
        <span>{gender}</span>
      </div>
      <div style={{ width: !isLargeMobile && tableSizes.ageWidth }}>
        {singleLine && <IconCalendarDate />}
        <span>{birthDate}, {age}</span>
      </div>
      <div style={{ width: !isLargeMobile && tableSizes.addressWidth, paddingRight: 30, ...(!isLargeMobile && { marginRight: 'auto' }) }}>
        {singleLine && <IconLocation />}
        <span>{fullAddress}</span>
      </div>
      {!singleLine &&
        <IconButton
          icon={IconPencil}
          title='Viewer details'
          className={styles.optionButton}
          onClick={handleViewerDetailsClick}
        />}
    </div>
  )
}

const ViewerInfoLine = inject(ROUTING_STORE, 'VIEWERS_STORE')(ViewerInfoLineComponent)
export { ViewerInfoLine }
